/**
 * fontタグのsize属性はpxではなく、1~7の数字で指定されるので、pxに変換する必要がある
 * リッチテキストエディタで許可しているリスト
 */
const FONT_SIZE_ATTRIBUTE_PX: Record<string, string> = {
  '1': '10px',
  '2': '13px',
  '3': '16px',
  '4': '18px',
  '5': '24px',
  '6': '32px',
  '7': '48px',
};

// HTMLFontElement を返すオーバーロードが deprecated なので、string に広げて Element 側に解決させる
const FONT_TAG_NAME: string = 'font';

const createSpanFromFontTag = (doc: Document, font: Element): HTMLSpanElement => {
  const span = doc.createElement('span');

  const style = font.getAttribute('style');
  if (style) {
    span.setAttribute('style', style);
  }

  // 属性より style の指定を優先する。CSS と同じ優先順位に合わせる
  const color = font.getAttribute('color');
  if (color && !span.style.color) {
    span.style.color = color;
  }

  const face = font.getAttribute('face');
  if (face && !span.style.fontFamily) {
    span.style.fontFamily = face;
  }

  const size = FONT_SIZE_ATTRIBUTE_PX[(font.getAttribute('size') || '').trim()];
  if (size && !span.style.fontSize) {
    span.style.fontSize = size;
  }

  return span;
};

/**
 * Tiptapはfontタグを解釈できないので、fontタグをspanタグに変換する必要がある
 * Tiptapはstyle属性以外は解釈できないので、fontタグの属性(color, face, size)はstyle属性に変換する必要がある
 */
export const convertFontTagToSpan = (html: string): string => {
  if (!html || !html.includes('<font')) {
    return html;
  }

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const fonts = doc.getElementsByTagName(FONT_TAG_NAME);
  while (fonts.length > 0) {
    const font = fonts[0];
    const span = createSpanFromFontTag(doc, font);

    while (font.firstChild) {
      span.appendChild(font.firstChild);
    }
    font.replaceWith(span);
  }

  return doc.body.innerHTML;
};
